import { fmtMoeda } from '@/lib/utils/formatters';
import { useApuracaoSN } from '@/contexts';
import type { SegregacaoLinhaReceita } from '@/services/SimplesNacional/Segregacao/api/types';

const COLUNAS = [
  { key: 'Receita_Bruta', label: 'Rec. Bruta' },
  { key: 'Devolução', label: 'Devolução' },
  { key: 'Receita_Liquida', label: 'Rec. Líquida' },
  { key: 'COFINS', label: 'COFINS' },
  { key: 'CSLL', label: 'CSLL' },
  { key: 'ICMS', label: 'ICMS' },
  { key: 'INSS', label: 'INSS' },
  { key: 'IRPJ', label: 'IRPJ' },
  { key: 'PIS', label: 'PIS' },
] as const;

interface ReceitasTableProps {
  data: SegregacaoLinhaReceita[];
  onClickLinha?: (linha: string) => void;
}

export function ReceitasTable({ data, onClickLinha }: ReceitasTableProps) {
  const { mostrarZeros } = useApuracaoSN();

  const linhas = mostrarZeros ? data : data.filter(r => r.Receita_Bruta !== 0);

  if (linhas.length === 0) {
    return (
      <p className="px-4 py-6 text-sm text-muted-foreground text-center">
        Nenhuma linha com valor. Ative "Mostrar valores zerados" para exibir todas.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b bg-muted/40">
            <th className="text-left px-4 py-2.5 font-medium text-muted-foreground whitespace-nowrap">
              Linha
            </th>
            {COLUNAS.map(c => (
              <th
                key={c.key}
                className="text-right px-4 py-2.5 font-medium text-muted-foreground whitespace-nowrap"
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {linhas.map((row, i) => (
            <tr key={i} className="border-b last:border-0 hover:bg-muted/20 transition-colors">
              <td className="px-4 py-2.5 font-medium whitespace-nowrap">
                {onClickLinha ? (
                  <button
                    className="text-primary underline-offset-2 hover:underline"
                    onClick={() => onClickLinha(row.Linha)}
                  >
                    {row.Linha}
                  </button>
                ) : (
                  row.Linha
                )}
              </td>
              {COLUNAS.map(c => (
                <td key={c.key} className="px-4 py-2.5 text-right tabular-nums whitespace-nowrap">
                  {fmtMoeda((row as unknown as Record<string, number>)[c.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
